/*
  Fetches the "Product hotspots" section from another page (the home page, by
  default), matched by its static CSS class rather than its auto-generated
  section id (which changes per template/theme, as "template--<id>__<key>").
  Injects it into a mount point on the current page, then re-runs the theme's
  existing hotspot/swiper init.

  Usage (inside a Custom Liquid section, on any page):
    <div data-shop-the-look-mount></div>
    <script src="{{ 'shop-the-look-embed.js' | asset_url }}" defer></script>

  What gets injected: the ".product_hotspots_wrapper" element itself is kept
  (so its color-scheme/background classes still apply), but Shopify's outer
  <section id="shopify-section-..."> shell is skipped, and the wrapper's own
  inner ".container" div is unwrapped (removed, keeping its children) so it
  doesn't nest inside whatever container the mount point already sits in.

  It also tags the mount point's own surrounding wrapper (the element that
  sits above its nearest ".container" ancestor — e.g. the Custom Liquid
  section's outer div) with a class, purely at runtime via JS, without
  touching that section's Liquid file.

  data-selector: optional, defaults to ".product_hotspots_wrapper" — the
                 element that gets kept as the injected root.
  data-inner-selector: optional, defaults to ".container" — the direct child
                 (inside data-selector) to unwrap. Set to "" to disable
                 unwrapping and inject the wrapper as-is.
  data-path: optional, defaults to the store's localized root ("/"). Use this
             to pull the section from a page other than the home page.
  data-parent-class: optional, defaults to "custom_hotspot_parent_wrapper".
                 Added to the element above the mount's nearest ".container"
                 ancestor (or the mount's direct parent, if no ".container"
                 ancestor is found). Set to "" to skip this entirely.
  data-parent-container-selector: optional, defaults to ".container" — the
                 ancestor selector used to locate that wrapper.
*/
(function () {
  function tagParentWrapper(mount) {
    var parentClass =
      mount.dataset.parentClass !== undefined
        ? mount.dataset.parentClass
        : "custom_hotspot_parent_wrapper";
    if (!parentClass) return;

    var containerSelector = mount.dataset.parentContainerSelector || ".container";
    var container = mount.closest(containerSelector);
    var wrapper = container ? container.parentElement : mount.parentElement;
    if (wrapper) {
      wrapper.classList.add(parentClass);
    }
  }

  function loadMount(mount) {
    if (!mount || mount.dataset.stlLoaded === "true") return;
    mount.dataset.stlLoaded = "true";

    tagParentWrapper(mount);

    var selector = mount.dataset.selector || ".product_hotspots_wrapper";
    var innerSelector =
      mount.dataset.innerSelector !== undefined ? mount.dataset.innerSelector : ".container";
    var path =
      mount.dataset.path ||
      (window.Shopify && Shopify.routes && Shopify.routes.root) ||
      "/";

    fetch(path)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var wrapper = doc.querySelector(selector);
        if (!wrapper) {
          console.warn(
            "shop-the-look-embed: no element matching \"" + selector + "\" found at " + path
          );
          return;
        }

        if (innerSelector) {
          var inner = wrapper.querySelector(innerSelector);
          if (inner) {
            wrapper.innerHTML = inner.innerHTML;
          }
        }

        mount.innerHTML = wrapper.outerHTML;
        mount.dispatchEvent(new CustomEvent("shopify:section:load", { bubbles: true }));
      })
      .catch(function (err) {
        console.error("shop-the-look-embed: failed to load", selector, "from", path, err);
      });
  }

  document.querySelectorAll("[data-shop-the-look-mount]").forEach(loadMount);
})();
